<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <tree-data ref="tree" @checkChange="checkChange"></tree-data>
        </el-col>
        <el-col :span="20" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <div style="float: left;height: 50px">
            <el-button type="primary" plain icon="el-icon-plus" @click="addCommunity()">新建</el-button>&nbsp;&nbsp;
            <el-input v-if="moduletag === 1" prefix-icon="el-icon-search" placeholder="按小区名称、地址搜索" v-model="searchKeyword1" style="width: 300px" clearable></el-input>
            <el-input v-else-if="moduletag === 2" prefix-icon="el-icon-search" placeholder="按机构名称、地址搜索" v-model="searchKeyword1" style="width: 300px" clearable></el-input>
            <el-input v-else prefix-icon="el-icon-search" placeholder="按小区/机构名称、地址搜索" v-model="searchKeyword1" style="width: 300px" clearable></el-input>&nbsp;
            <el-button type="primary" plain @click="searchWord()">搜索</el-button>
          </div>
          <div style="float: right;margin-right: 20px">
          </div>
          <div style="clear: both"></div>
          <div style="max-height: calc(100% - 100px);overflow-y: auto;margin-right: 20px">
            <el-table
              v-loading="loading"
              element-loading-text="加载中，请耐心等待。"
              :data="tbdata"
              border
              style="width: 100%"
              highlight-current-row
              ref="singleTable">
              <el-table-column
                type="index"
                label="序号"
                width="50"
              align="center">
              </el-table-column>
              <el-table-column
                v-if="moduletag === 1"
                prop="name"
                label="小区名称"
                min-width="130"
                align="center">
              </el-table-column>
              <el-table-column
                v-else-if="moduletag === 2"
                prop="name"
                label="机构名称"
                min-width="130"
                align="center">
              </el-table-column>
              <el-table-column
                v-else
                prop="name"
                label="小区/机构名称"
                min-width="130"
                align="center">
              </el-table-column>
              <el-table-column
                v-if="moduletag === 3"
                label="类型"
                min-width="45"
                align="center">
                <template slot-scope="scope">
                  <span>{{getZoneType(scope.row.zone_type)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="所属组织"
                min-width="80"
                align="center">
                <template slot-scope="scope">
                  <span>{{getOnOrg(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                label="地址"
                min-width="165"
                align="center">
              </el-table-column>
              <el-table-column
                prop="lng"
                label="经度"
                min-width="85"
                align="center">
              </el-table-column>
              <el-table-column
                prop="lat"
                label="纬度"
                min-width="85"
                align="center">
              </el-table-column>
              <el-table-column
                prop="createtime"
                label="录入时间"
                min-width="110"
                align="center">
              </el-table-column>
              <el-table-column align="center" label="操作" min-width="90"  class-name="small-padding fixed-width">
                <template slot-scope="scope">
                  <i :title="scope.row.zone_type === 1 ? '家庭管理' : '房间管理'" class="el-icon-s-home" style="cursor: pointer; font-size: 18px;color: #1950e5" @click="seeFamilyOpen(scope.row)"></i>
                  <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editCommunity(scope.row)"></i>
                  <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delCommunity(scope.row)"></i>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 10px;height: 40px;text-align: center">
            <el-pagination v-fixZoom
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCells">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--created update-->
    <el-dialog
      :visible.sync="addEditShow"
      v-if="addEditShow"
      width="800px"
      :show-close="true"
      :close-on-click-modal="false"
      center
      top="10vh"
      class="all-open">
      <community-add-edit v-model="addEditShow" :commObj="objRow" @getFatherCid="getFatherCid"></community-add-edit>
    </el-dialog>
    <!--查看家庭/机构-->
    <el-dialog
      :visible.sync="relation"
      v-if="relation"
      width="95%"
      :show-close="true"
      :close-on-click-modal="false"
      center
      top="7vh">
      <div style="height: 650px;margin-top: -40px;">
        <div class="title-top-alarm">
          <div>
            <span>{{titleName}}</span>
          </div>
<!--          <div class="line-title"></div>-->
        </div>
        <div style="height: 620px">
          <el-relation :communityData="communityObj" @fatherCommunity="getCommunity"></el-relation>
        </div>
      </div>
    </el-dialog>
    <!--语音通知 暂弃-->
    <el-dialog
      :visible.sync="voiceShow"
      v-if="voiceShow"
      width="650px"
      :show-close="true"
      :close-on-click-modal="false"
      class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>语音通知</span>
        </div>
        <div class="line-title"></div>
      </div>
      <voice-open-show :device="voiceObj" v-model="voiceShow" @getFatherVoice="getFatherVoice"></voice-open-show>
    </el-dialog>
  </div>
</template>

<script>
import treeData from '../treeData/treeData.vue'
import {queryorgcommunity, deleteorgcommunity} from '../../api/community'
import {queryorghome} from '../../api/relation'
import communityAddEdit from './childComponents/communityAddEdit'
import elRelation from './relation'
import voiceOpenShow from './childComponents/voiceOpenShow'
export default {
  name: 'community',
  components: {treeData, voiceOpenShow, communityAddEdit, elRelation},
  data () {
    return {
      isShangHai: true,
      // 左边
      orgData: [],
      searchKeyword1: '',
      searchKeyword: '',
      isFirst: [],
      titleName: '家庭/机构管理',
      communityObj: {
        orgId: [],
        orgData: [],
        orgTree: [],
        orgcommunitys: [],
        orghomes: [],
        row: '',
        isAll: false
      },
      // 右边
      tableData: [],
      showTable: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addEditShow: false,
      objRow: {
        type: '',
        openTitle: '',
        orgTree: [],
        orgids: [],
        isAdd: true,
        row: {}
      },
      // 家庭/机构
      relation: false,
      voiceShow: false,
      voiceObj: {
        device: '',
        org: [],
        community: [],
        home: [],
        push_type: 3
      },
      orghomes: [],
      moduletag: ''
    }
  },
  created () {
    this.moduletag = this.$store.state.user.moduletag
    // console.log(this.moduletag)
    this.isShangHai = this.$store.state.user.isShangHai
    this.golobleObject.updateTableCommunity = this.getCommunityTable
    this.getQueryOrgHome()
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  methods: {
    getCommunity (data) {
      this.orghomes = data
      this.communityObj.orghomes = this.orghomes
    },
    // 所以家庭
    getQueryOrgHome () {
      queryorghome().then(res => {
        this.orghomes = res.data.orghomes
        this.communityObj.orghomes = this.orghomes
      }).catch(() => {})
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 左边树
    handleTreeClick (item) {},
    handleCheckChange () {
      this.currentPage = 1
      this.isFirst = this.$refs.treeData.getCheckedKeys()
      this.communityObj.orgId = this.isFirst
      // console.log(this.orgData)
      this.objRow.orgids = this.isFirst
      this.getEndTable()
    },
    checkChange (obj) {
      if (obj.type === 'check') {
        this.isFirst = obj.orgids
        this.currentPage = 1
        this.communityObj.orgId = this.isFirst
        this.objRow.orgids = this.isFirst
        this.getEndTable()
      } else if (obj.type === 'data') {
        this.orgData = obj.orgData
        this.objRow.orgTree = obj.orgData
        this.communityObj.orgData = obj.orgData
        this.communityObj.orgTree = obj.treeData
        this.getCommunityTable()
      }
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getCommunityTable () {
      this.loading = true
      queryorgcommunity().then(res => {
        let arr = []
        if (this.moduletag === 1) {
          for (let i = 0; i < res.data.orgcommunitys.length; i++) {
            // zone_type
            if (res.data.orgcommunitys[i].zone_type === 1) {
              arr.push(res.data.orgcommunitys[i])
            }
          }
        } else if (this.moduletag === 2) {
          for (let i = 0; i < res.data.orgcommunitys.length; i++) {
            // zone_type
            if (res.data.orgcommunitys[i].zone_type === 2) {
              arr.push(res.data.orgcommunitys[i])
            }
          }
        } else {
          arr = res.data.orgcommunitys
        }
        this.voiceObj.community = arr
        let isTime = arr.length / this.pageSize
        if (isTime !== parseInt(isTime)) {
          isTime = parseInt(isTime) + 1
        }
        if (isTime < this.currentPage) {
          if (this.currentPage !== 1) {
            this.currentPage -= 1
          }
        }
        this.tableData = arr
        this.communityObj.orgcommunitys = this.tableData
        this.getEndTable()
        this.loading = false
      }).catch(() => {})
    },
    getEndTable () {
      this.showTable = []
      if (this.isFirst.length === 0) {
        this.showTable = this.tableData
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.isFirst.indexOf(this.tableData[i].orgid) > -1) {
            this.showTable.push(this.tableData[i])
          }
        }
      }
    },
    searchWord () {
      this.currentPage = 1
      this.searchKeyword = this.searchKeyword1
    },
    // table数据入口（tbdata）
    searchFilterWord () {
      const data = this.showTable
      const vm = this
      const search = data.filter((val) => {
        if (val.address.includes(vm.searchKeyword) || val.name.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      return arr
    },
    getZoneType (type) {
      if (type === 1) {
        return '小区'
      } else if (type === 2) {
        return '机构'
      } else {
        return type
      }
    },
    getOnOrg (row) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (row.orgid === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    getFatherCid (obj) {},
    addCommunity () {
      let moduletag = this.$store.state.user.moduletag
      if (moduletag === 2) {
        this.objRow.openTitle = '新建机构'
      } else if (moduletag === 1) {
        this.objRow.openTitle = '新建小区'
      } else {
        // 3
        this.objRow.openTitle = '新建小区/机构'
      }
      this.objRow.isAdd = true
      this.objRow.row = {}
      this.addEditShow = true
    },
    editCommunity (row) {
      if (row.zone_type === 1) {
        this.objRow.openTitle = '更新小区'
      } else if (row.zone_type === 2) {
        this.objRow.openTitle = '更新机构'
      } else {
        this.objRow.openTitle = '更新小区/机构'
      }
      this.objRow.isAdd = false
      this.objRow.row = row
      this.addEditShow = true
    },
    delCommunity (row) {
      this.$confirm('此操作将永久删除该【' + row.name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          cids: [row.id],
          zone_type: row.zone_type
        }
        deleteorgcommunity(data).then(res => {
          this.$notify({
            title: '成功',
            message: '删除小区/机构成功',
            type: 'success',
            duration: 2000
          })
          this.getCommunityTable()
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除小区/机构失败'
          })
        })
      }).catch(() => {})
    },
    openVoice () { // 暂弃
      this.voiceShow = true
    },
    seeFamilyOpen (row) {
      let arr = []
      for (let i = 0; i < this.orghomes.length; i++) {
        if (row.id === this.orghomes[i].cid) {
          arr.push(this.orghomes[i])
        }
      }
      if (row.zone_type === 1) {
        this.titleName = '【' + row.name + '】家庭管理'
      } else if (row.zone_type === 2) {
        this.titleName = '【' + row.name + '】房间管理'
      } else {
        this.titleName = '【' + row.name + '】家庭/房间管理'
      }
      this.communityObj.isAll = false
      this.communityObj.row = row
      this.communityObj.orghomes = arr
      this.relation = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/community.vue